import http from "@/utils/http";


export const HolidayRuleApi = {
	getHolidayPage (queryForm) {
		return http.get("/nexus/acsHolidayRule/page",queryForm);
	},
	getHolidaySave (holidayForm) {
		return http.post("/nexus/acsHolidayRule/save",holidayForm);
	},
	getById (id) {
		return http.get(`/nexus/acsHolidayRule/query/${id}`);
	},
	getRuleNumber () {
		return http.get(`/nexus/acsHolidayRule/queryUndistributedRuleNumber`);
	},
	deleteById (id) {
		return http.get(`/nexus/acsHolidayRule/delete/${id}`);
	},
}

